module.exports = __webpack_public_path__ + "images/liinilaevad/favicon-96x96.png";